// AuthoringEnablePanel.jsx
import React, { Component, createRef } from 'react';
import './AuthoringEnablePanel.css';
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import axios from 'axios';
import { uniq } from 'underscore'
import { Modal } from "react-bootstrap";
import { imsLoader, popCancelBttn } from '../../assets/index';
import { LocationOrigin, getCurrentDate } from '../../utils/utilityServices';
import { Authentication } from "../../utils/authenticationUtilityServices";
import GenAIResultIndex from './AuthoringEnableResultIndex';
import trackingService from "../../services/trackingService";
import AuthoringDisclaimer from './AuthoringDisclaimer'


let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
let _timeoutTime = (1000 * (300));
export default class AuthoringEnablePanel extends Component {
    constructor(props) {
        super(props);
        this.messagesEnd = createRef();
        this.myDiv = createRef();
        this.myHeaderRef = React.createRef();
        this.state = {
            newQuestion: "",
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            sessionID: uuidv4(),
            question: "",
            threadID: uuidv4(),
            spinnerMessage: '',
            isLoaded: false,
            chatConversation: [],
            isProcessing: false,
            scrollToBottomRandom: Math.random(),
            firstDivHeight: 175,
            showDisclaimerPopup: false,
        };
    }

    componentDidMount() {
        // 2. Measure height after the component is rendered
        this.updateHeight();
        // Optional: Update on window resize to keep it responsive
        window.addEventListener('resize', this.updateHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateHeight);
    }

    updateHeight = () => {
        if (this.myHeaderRef?.current) {
            this.setState({
                firstDivHeight: this.myHeaderRef.current.clientHeight + 180
            });
        }
    };
    // utility to build class names with the prefix

    handleChange = (e) => {
        this.setState({ newQuestion: e.target.value });
    };


    handleKeyDown = async (event) => {
        if (['Enter'].includes(event.key) && !event.shiftKey && this.state.newQuestion && this.state.newQuestion.trim()) {
            event.preventDefault();
            event.returnValue = false;
            await this.handleOnClickSend();

        }
    }
    handleNewQuestion = (e) => {
        this.setState({ newQuestion: e.target.value })
    }
    handleOnClickSend = () => {
        let { newQuestion, } = this.state;
        this.runGenAISearchStream(newQuestion);
    }
    processChatHistories = (index) => {
        let { chatConversation, threadID, sessionID } = this.state;
        let _chatHistories = {};
        let _chatConversation = Object.assign([], chatConversation);
        _chatConversation = _chatConversation.filter((x, i) => i < index).filter(x => x.threadID === threadID);
        if (chatConversation.length !== 0 && _chatConversation.length === 0 && index !== 0) {
            _chatConversation = Object.assign([], chatConversation);
            _chatConversation = _chatConversation.filter(x => x.threadID === threadID);
        }
        try {
            _chatHistories[sessionID] = [];
            _chatConversation.forEach((resItem) => {
                let finalAns = resItem.DisplayString.map(x => x.display_ans).join(' ');
                _chatHistories[sessionID].push({ "Question": resItem.Question, "Answer": finalAns })
            })
        } catch (error) {
            console.log(error)
        }
        return _chatHistories;
    }
    processSourceSearchIds = (index) => {
        let { chatConversation } = this.state;
        let _sourceSearchIds = [];
        try {
            let _chatConversation = Object.assign([], chatConversation);
            if (index - 1 >= 0 && index - 1 < _chatConversation.length) {
                _sourceSearchIds = _chatConversation[index - 1].Sources.map(x => x.searchID);
            }
            _sourceSearchIds = uniq(_sourceSearchIds);
        } catch (error) {
            console.log(error)
        }
        return _sourceSearchIds;
    }

    indextrackingData = async (eventid, questionType, question, userQuestion, outputAnswer, sources, displayString, recommandationResults, lastCreatedDatehour, isGetAnyAns, isSuccess) => {
        let { sessionID, threadID } = this.state;
        let answeringinfo = {
            session_id: sessionID,
            thread_id: threadID,
            question_type: questionType,
            question: question,
            userQuestion: userQuestion ? userQuestion : question,
            output_answer: outputAnswer,
            sources: sources,
            display_string: displayString,
            recommandation_results: recommandationResults,
            isGetAnyAns: isGetAnyAns,
            isSuccess: isSuccess,
            lastcreateddatehour: lastCreatedDatehour,
        }

        this.indexData({ ...answeringinfo, "eventid": eventid });

    }
    indexData = (genaianswering2info) => {
        let { item } = this.props
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Conducted Question at AI Enabled`,
            '',
            window.location.href, '', '', item.docTitle, item.majorVersionNumber, item.documentNumber, item.searchID, '', item.tempJNJDrugs, item.docType, '', '', '', item.domain, '', '', item.createdDate, '', '',
            {}, {}, genaianswering2info);
    }
    runGenAISearchStream = async (question) => {
        let { sessionID, isFirstQuestion, threadID } = this.state;
        let { item } = this.props
        let _chatConversation = this.state.chatConversation;
        let _lastCreatedDatehour = getCurrentDate();

        let url = '';
        let _chatHistory = [];
        let query = question.trim();
        let isAnyEventStream = false;
        this.setState({ isProcessing: true })

        url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_answers_stream`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_answers_stream`
        }
            _chatHistory = this.processChatHistories(_chatConversation.length);
        let _sourceSearchId = this.processSourceSearchIds(_chatConversation.length);
        var config;
        var eventid = uuidv4();
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
        let _function = localStorage.getItem('function').replace(/"/g, '');
        if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP")) {
            _function = `MISE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("MISEHCP")) {
            _function = `MISE`;
        }
        else if (userAccessGroup.includes("AllContent")) {
            _function = localStorage.getItem('function').replace(/"/g, '');
        }




        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let _body = {
            "query": query,
            "filters": "",
            "function": _function,
            "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
            "userproducts": localStorage.getItem('userproducts'),
            "region": localStorage.getItem('region'),
            "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
            "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
            "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
            "from": 0,
            "size": 7,
            "sortBy": "",
            "sortField": "",
            "defaultOperator": "or",
            "sessionID": sessionID,
            "threadID": threadID,
            "chat_history": _chatHistory,
            "IsComprehensive": false,
            "sourceSearchId": _sourceSearchId,
            "isMoreInformation": false,
            "isFirstQuestion": _chatConversation.length === 0,
            "includePubMed": false,
            "rangeField": "",
            "isDateRange": false,
            "toRange": "",
            "fromRange": "",
            "searchId": [item.searchID],
        }
        const body = JSON.stringify(_body);
        this.controller = new AbortController();

        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: _headers,
                body,
                signal: this.controller.signal
            });

            if (!res.ok || !res.body) {
                console.error('Stream not available', res.status);
                return;
            } else {

                const decoder = new TextDecoder('utf-8');
                const reader = res.body.getReader();
                this.reader = reader;
                let buffer = '';

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    buffer += decoder.decode(value, { stream: true });

                    // simple SSE parsing: split on double-newline
                    let parts = buffer.split('\n\n');
                    buffer = parts.pop(); // last fragment might be incomplete

                    for (const part of parts) {
                        // each 'part' is one event block
                        const lines = part.split(/\r?\n/);
                        let event = 'message';
                        let dataLines = [];
                        for (const line of lines) {
                            if (line.startsWith('event:')) {
                                event = line.replace(/^event:\s*/, '');
                            } else if (line.startsWith('data:')) {
                                dataLines.push(line.replace(/^data:\s*/, ''));
                            }
                            // ignore id:, retry:, etc. or parse as needed
                        }
                        const datastr = dataLines.join('\n');
                        // handle event (here we just push the data)
                        let _response = JSON.parse(datastr)
                        isAnyEventStream = true;
                        if (_response && _response.status_code && _response.status_code == 200) {
                            if (_response.message && (_response.message == "Processing Completed" || _response.message == "DocNo_Query" || _response.message == "DOI_Query" || _response.message == "TitleSearch_Query")) {
                                let response = _response.API_result;
                                if (response.display_string && response.display_string.length > 0) {
                                    let _relevantInformation = {
                                        0: {
                                            Sources: response.sources,
                                            DisplayString: response.display_string,
                                            CreatedDatehour: _lastCreatedDatehour
                                        }
                                    }
                                    _chatConversation.push({ IsSucceed: true, Question: question, OutputAnswer: response.output_answer, Sources: response.sources, DisplayString: response.display_string, RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: response.recommandation_results, messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: true, isSuccess: true })

                                    this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, response.rephrased_question, response.output_answer, response.sources, response.display_string, response.recommandation_results, _lastCreatedDatehour, true, true)

                                } else {
                                    let _relevantInformation = {
                                        0: {
                                            Sources: [],
                                            DisplayString: [],
                                            CreatedDatehour: _lastCreatedDatehour
                                        }
                                    }
                                    _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })

                                    this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, true)
                                }
                            }
                        } else {
                            let _relevantInformation = {
                                0: {
                                    Sources: [],
                                    DisplayString: [],
                                    CreatedDatehour: _lastCreatedDatehour
                                }
                            }
                            _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })
                            this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, true)
                        }
                        if (!isAnyEventStream) {
                            let _relevantInformation = {
                                0: {
                                    Sources: [],
                                    DisplayString: [],
                                    CreatedDatehour: _lastCreatedDatehour
                                }
                            }
                            _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })
                            this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, true)
                        }
                    }
                }
            }
        } catch (err) {

            if (err.name === 'AbortError') {
                console.log('Stream aborted');
            } else {
                console.error('Stream error', err);
            }

            let _relevantInformation = {
                0: {
                    Sources: [],
                    DisplayString: [],
                    CreatedDatehour: _lastCreatedDatehour
                }
            }
            _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })
            this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, false);
        } finally {
            this.setState({
                chatConversation: _chatConversation,
                isProcessing: false,
                newQuestion: '',
                isFirstQuestion: false,
            }, async () => {
                this.scrollToBottom();
            })
        }

    }
    runGenAISearch = async (question) => {
        let { sessionID, isFirstQuestion, threadID } = this.state;
        let { item } = this.props
        let _chatConversation = this.state.chatConversation;
        let _lastCreatedDatehour = getCurrentDate();

        let url = '';
        let _chatHistory = [];
        let query = question.trim();

        this.setState({ isProcessing: true })

        url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_answers`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_answers`
        }
        _chatHistory = this.processChatHistories(_chatConversation.length);
        let _sourceSearchId = this.processSourceSearchIds(_chatConversation.length);
        var config;
        var eventid = uuidv4();
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
        let _function = localStorage.getItem('function').replace(/"/g, '');
        if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP")) {
            _function = `MISE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("MISEHCP")) {
            _function = `MISE`;
        }
        else if (userAccessGroup.includes("AllContent")) {
            _function = localStorage.getItem('function').replace(/"/g, '');
        }


        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                "query": query,
                "filters": "",
                "function": _function,
                "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                "userproducts": localStorage.getItem('userproducts'),
                "region": localStorage.getItem('region'),
                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                "from": 0,
                "size": 7,
                "sortBy": "",
                "sortField": "",
                "defaultOperator": "or",
                "sessionID": sessionID,
                "threadID": threadID,
                "chat_history": _chatHistory,
                "IsComprehensive": false,
                "sourceSearchId": _sourceSearchId,
                "isMoreInformation": false,
                "isFirstQuestion": _chatConversation.length === 0,
                "includePubMed": false,
                "rangeField": "",
                "isDateRange": false,
                "toRange": "",
                "fromRange": "",
                "searchId": [item.searchID],
            },
            timeout: _timeoutTime
        }
        axios(config)
            .then(async (resp) => {

                let response = resp.data;
                if (response.display_string && response.display_string.length > 0) {
                    let _relevantInformation = {
                        0: {
                            Sources: response.sources,
                            DisplayString: response.display_string,
                            CreatedDatehour: _lastCreatedDatehour
                        }
                    }
                    _chatConversation.push({ IsSucceed: true, Question: question, OutputAnswer: response.output_answer, Sources: response.sources, DisplayString: response.display_string, RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: response.recommandation_results, messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: true, isSuccess: true })

                    this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, response.rephrased_question, response.output_answer, response.sources, response.display_string, response.recommandation_results, _lastCreatedDatehour, true, true)

                } else {
                    let _relevantInformation = {
                        0: {
                            Sources: [],
                            DisplayString: [],
                            CreatedDatehour: _lastCreatedDatehour
                        }
                    }
                    _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })

                    this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, true)
                }

            })
            .catch(async (error) => {

                let _relevantInformation = {
                    0: {
                        Sources: [],
                        DisplayString: [],
                        CreatedDatehour: _lastCreatedDatehour
                    }
                }
                _chatConversation.push({ IsSucceed: false, Question: question, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], DisplayString: [], RelevantInformation: _relevantInformation, ShowRelevantInformation: false, RecommandationResults: [], messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: eventid, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, isGetAnyAns: false, isSuccess: true })
                this.indextrackingData(eventid, isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", question, question, "No Answer found. Please try a new question.", [], [], [], _lastCreatedDatehour, false, false);
                console.log("error", error);
            })
            .finally(async () => {
                this.setState({
                    chatConversation: _chatConversation,
                    isProcessing: false,
                    newQuestion: '',
                    isFirstQuestion: false,
                }, async () => {
                    this.scrollToBottom();
                })
            });


    }

    renderChatConversation = () => {
        let { chatConversation, customWidth, customHeight, sessionID } = this.state;

        return (<>
            {chatConversation.map((conversation, conversationIndex) => {
                let { Question, OutputAnswer, Sources, DisplayString,
                    isGetAnyAns, isSuccess, lastCreatedDatehour, RelevantInformation } = conversation;


                return (<React.Fragment key={`GenAIResultIndex-${conversation.eventid}-${conversationIndex}`}>
                    <GenAIResultIndex eventid={conversation.eventid} customWidth={customWidth} customHeight={customHeight} Question={Question} OutputAnswer={OutputAnswer}
                        Sources={Sources} DisplayString={DisplayString}
                        conversationIndex={conversationIndex}
                        sessionID={sessionID} questionType={conversation.questionType} threadID={conversation.threadID}
                        lastCreatedDatehour={lastCreatedDatehour}
                        isGetAnyAns={isGetAnyAns} isSuccess={isSuccess}
                        RelevantInformation={RelevantInformation}
                    />
                    {(conversationIndex < chatConversation.length - 1) && <hr style={{ margin: "0 20px" }}></hr>}
                </React.Fragment>)
            })}
            <div style={{ float: "left", clear: "both", height: "5px" }}
                ref={(el) => { this.messagesEnd = el; }}>
            </div>
        </>)


    }
    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
        this.setState({ scrollToBottomRandom: Math.random() });
    }

    handleDisclaimerClose = async () => {
        this.setState({ showDisclaimerPopup: false });
    }
    render() {
        const { newQuestion, spinnerMessage, chatConversation, firstDivHeight, showDisclaimerPopup } = this.state;
        return (
            <div className="gen-ai-enable-authoring-container">
                <div ref={this.myHeaderRef} className="gen-ai-enable-authoring-header">
                    <h2 className="gen-ai-enable-authoring-title">{this.props.item.docTitle}</h2>
                    <button onClick={() => { this.props.handleShowAuthoringEnablePanelClick() }}>
                        {/* <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> */}
                        <img src={popCancelBttn} width="22" height="22" alt="" />
                    </button>
                </div>

                <div className="gen-ai-enable-authoring-content" style={{ height: `calc(90vh - ${firstDivHeight}px)` }}>
                    {this.renderChatConversation()}
                </div>
                <div className="gen-ai-enable-authoring-search-textarea-main">
                    <div
                        className="gen-ai-enable-authoring-search-form"
                        role="search"
                        aria-label="Search"
                    >
                        <div className="gen-ai-enable-authoring-search-input-wrap">
                            {/* left small plus icon inside input area */}
                            <textarea
                                className="gen-ai-enable-authoring-input"
                                // type="text"
                                name="citationText"
                                value={newQuestion}
                                onKeyDown={this.handleKeyDown}
                                onChange={(e) => this.handleNewQuestion(e)}
                                placeholder={(chatConversation && chatConversation.length > 0) ? "Ask follow-up" : "Ask a question ..."}
                                aria-label="Search query"
                            />

                            <button
                                // type="submit"
                                className="gen-ai-enable-authoring-search-btn"
                                aria-label="Search"
                                disabled={!newQuestion.trim()}
                                onClick={(e) => this.handleOnClickSend()}
                                style={!newQuestion ? { background: "#cecece", cursor: "not-allowed" } : { background: "#EB1700" }}
                                title={!newQuestion ? "Ask follow-up" : "Search"}
                            >
                                <svg fill="#ffffff" width="36" height="36" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-117.76 -117.76 747.52 747.52" enable-background="new 0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="0.00512">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                                        <rect x="-117.76" y="-117.76" width="747.52" height="747.52" rx="373.76" fill={!newQuestion ? "#cecece" : "#EB1700"} strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M325.8,0C223,0,139.6,83.4,139.6,186.2c0,33.5,9,64.8,24.4,92L0,442.2l23.3,46.5L69.8,512l164-164 c27.1,15.5,58.5,24.4,92,24.4C428.6,372.4,512,289,512,186.2S428.6,0,325.8,0z M325.8,314.2c-70.7,0-128-57.3-128-128 c0-70.7,57.3-128,128-128s128,57.3,128,128C453.8,256.9,396.5,314.2,325.8,314.2z"></path>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="gen-ai-enable-authoring-footer-content">
                    <p>iMedical Search GenAI Answers can make mistakes please verify critical information. You are reminded that no personal information or GxP data should be uploaded onto this platform, and you are required to comply with the. <button type="button" className="authoring-model-body-content-link" onClick={() => { this.setState({ showDisclaimerPopup: true }) }}>GenAI Adherence Policy</button></p>
                </div>
                {this.state.isProcessing &&
                    <Modal
                        show={this.state.isProcessing}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="savePopUp"
                        className="gen-ai-enable-authoring-search-spinner-popup"
                        backdropClassName="gen-ai-enable-authoring-search-spinner-popup-backdrop"
                        scrollable={true}>
                        <div style={{ padding: "0 5%" }}>
                            <div style={{ fontSize: "14px", textAlign: "center" }}>
                                <Modal.Body>
                                    <img src={imsLoader} alt="" width={100} height={100} />
                                    <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait while finding answers.`} </div>
                                </Modal.Body>
                            </div>
                        </div>
                    </Modal>}
                {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={this.handleDisclaimerClose} />}

            </div>
        );
    }
}


